var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5324_82400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.0526,
    height: 15.0526,
    transform: "matrix(-1.19249e-08 1 1 2.38498e-08 0.476562 0.473633)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5324_82400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77089 7.73342L9.21694 5.28736C9.33193 5.17238 9.38942 5.02603 9.38942 4.84833C9.38942 4.67062 9.33193 4.52428 9.21694 4.40929C9.10196 4.29431 8.95561 4.23682 8.77791 4.23682C8.6002 4.23682 8.45386 4.29431 8.33887 4.40929L5.45378 7.29438C5.32834 7.41982 5.26563 7.56617 5.26563 7.73342C5.26563 7.90067 5.32834 8.04701 5.45378 8.17245L8.33887 11.0575C8.45386 11.1725 8.6002 11.23 8.77791 11.23C8.95561 11.23 9.10196 11.1725 9.21694 11.0575C9.33193 10.9426 9.38942 10.7962 9.38942 10.6185C9.38942 10.4408 9.33193 10.2945 9.21694 10.1795L6.77089 7.73342Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.74ceadc20880852b135134a4b2ee2564.svg";
export { ForwardRef as ReactComponent };